module.exports = __webpack_public_path__ + "1d4ca211b62891e313c7c77255790c66.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/12_column_large_x1/public/history/9.jpg
// module id = 258
// module chunks = 0